// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","tableHeader":"OrderTable_tableHeader__vF-8v"};